<div
    class="row"
    id="{{tool.type}}FeatureTable">
    @if (businessAttrs.errors.length) {
        <div class="col-xs-12 mgb10">
            <div class="feature-business-table-error">
                <div class="panel panel-default">
                    <div
                        class="panel-heading"
                        (click)="businessAttrs.showError = !businessAttrs.showError">
                        <span>Error</span>
                        <span class="badge">{{businessAttrs.errors.length}}</span>
                        <i
                            class="nlrp-icon"
                            [ngClass]="businessAttrs.showError ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                    </div>
                    @if (businessAttrs.showError) {
                        <div class="panel-body">
                            @for (error of businessAttrs.errors; track error) {
                                <div>{{error}}</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    @if (businessAttrs.warnings.length) {
        <div class="col-xs-12 mgb10">
            <div class="feature-business-table-warning">
                <div class="panel panel-default">
                    <div
                        class="panel-heading"
                        (click)="businessAttrs.showWarning = !businessAttrs.showWarning">
                        <span>Warning</span>
                        <span class="badge">{{businessAttrs.warnings.length}}</span>
                        <i
                            class="nlrp-icon"
                            [ngClass]="businessAttrs.showWarning ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"></i>
                    </div>
                    @if (businessAttrs.showWarning) {
                        <div class="panel-body">
                            @for (warning of businessAttrs.warnings; track warning) {
                                <div>{{warning}}</div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    <div class="col-xs-12 mgb10">
        <div class="feature-business-table-total pull-left">
            <div title="Total number of features">
                <span class="badge grey">{{getParentFeatureCount()}}</span> features
            </div>
            <div title="Number of features selected in the list">
                <span class="badge">{{selectedAttrsList.length}}</span> selected
            </div>
        </div>
        <div class="feature-business-table-tools pull-right">
            @if ((tool.permissions | hasPermissions) && tool.enableAddAnnotation) {
                <div
                    class="disabled-save-association-btn-tooltip"
                    [title]="getAddAnnotationTooltip()">
                    <button
                        id="saveAnnotationAssociationBtn"
                        type="button"
                        class="disabled-save-association-btn-tooltip btn btn-default nlr-icon-btn mgr10"
                        [ngClass]="{active: annotationToolActive}"
                        [disabled]="addAnnotationIsDisabled()"
                        (click)=" toggleAnnotationTool()">
                        <i class="nlrp-icon nlrp-icon-annotation"></i>
                    </button>
                </div>
            }
            @if ((tool.permissions | hasPermissions) && isSelectAllBurdenedLotPolygons()) {
                <button
                    type="button"
                    class="disabled-save-association-btn-tooltip btn btn-default nlr-icon-btn mgr10"
                    title="Select all burdened lot polygons"
                    [disabled]="associationIsDisabled()"
                    (click)="selectAllBurdenedLotPolygons()">
                    <i class="nlrp-icon nlrp-icon-lot"></i>
                </button>
            }

            @if ((tool.permissions | hasPermissions) && showStartFeatureAssociation()) {
                <div
                    class="disabled-save-association-btn-tooltip"
                    [title]="associationTooltip()">
                    <button
                        type="button"
                        class="btn btn-default nlr-icon-btn mgr10"
                        id="startFeaturesAssociationBtn"
                        title="Start features association"
                        [disabled]="associationIsDisabled()"
                        (click)="startFeaturesAssociation()">
                        <i
                            class="nlrp-icon"
                            [ngClass]="startFeatureAssociationIcon()"></i>
                    </button>
                </div>
            }

            @if ((tool.permissions | hasPermissions) && showSaveFeatureAssociation()) {
                <button
                    id="save-association-btn"
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    title="Save features association"
                    [disabled]="businessAttrs.errors.length || (tool.permissions | disabledByPermissions)"
                    [ngStyle]="{'pointer-events': saveAssociationPointerEventsStyle()}"
                    (click)="saveFeaturesAssociation()">
                    <i class="nlrp-icon nlrp-icon-accept"></i>
                </button>
            }

            @if (showCancelFeatureAssociation()) {
                <button
                    id="cancel-association-btn"
                    type="button"
                    class="btn btn-warning nlr-icon-btn mgr10"
                    title="Cancel features association"
                    (click)="cancelFeaturesAssociation()">
                    <i class="nlrp-icon nlrp-icon-close-cancel"></i>
                </button>
            }

            @if ((tool.permissions | hasPermissions) && isDeleteSelectedFeaturesVisible()) {
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn"
                    id="deleteAttributesBtn"
                    title="Delete selected features"
                    [disabled]="deleteSelectedFeaturesIsDisabled()"
                    (click)="deleteSelectedFeatures()">
                    <i class="nlrp-icon nlrp-icon-trash"></i>
                </button>
            }

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                title="Hide unselected features"
                (click)="hideShowUnselectedRows()"
                [ngClass]="{active: hideUnselectedRows}"
                [disabled]="disabled || featuresAssociationActive || annotationToolActive">
                <i class="nlrp-icon nlrp-icon-compress-selected-feature-list"></i>
            </button>

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                title="Clear selected features"
                (click)="clearAllRows()"
                [disabled]="disabled || featuresAssociationActive || annotationToolActive">
                <i class="nlrp-icon nlrp-icon-remove-circle"></i>
            </button>

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                title="Open/Close feature filter"
                [ngClass]="showFilter || filterApplied ? 'active' : ''"
                (click)="showFilter = !showFilter;"
                [disabled]="disabled || featuresAssociationActive || annotationToolActive"
                cdkOverlayOrigin
                #showFilterTrigger="cdkOverlayOrigin"
                data-cdkOverlayContainerSelector="#attributeViewerOverlayContainer">
                <i class="nlrp-icon nlrp-icon-filter-off"></i>
            </button>

            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                title="Open/close column chooser"
                [ngClass]="showColumnSettings ? 'active' : ''"
                (click)="showColumnSettings = !showColumnSettings;"
                [disabled]="disabled || featuresAssociationActive || annotationToolActive"
                cdkOverlayOrigin
                #showColumnSettingsTrigger="cdkOverlayOrigin"
                data-cdkOverlayContainerSelector="#attributeViewerOverlayContainer">
                <i class="nlrp-icon nlrp-icon-column-chooser"></i>
            </button>

            @if ((['IN_DESIGN', 'EDIT_INTEREST', 'EDIT_DESIGN', 'VIEW_DESIGN'] | hasPermissions) && tool.type === 'interest') {
                <button
                    type="button"
                    class="btn btn-default nlr-icon-btn mgl10"
                    title="Create a new interest or notification"
                    [ngClass]="{'active': isEditorActive()}"
                    (click)="openNewInterest()"
                    [disabled]="createInterestIsDisabled()">
                    @if (tool.type === 'interest') {
                        <i class="nlrp-icon"> Ƃ </i>
                    }
                </button>
            }

            <span [title]="getDisabledEditAttributesTooltip()">
                @if ((['EDIT_DESIGN', 'VIEW_DESIGN'] | hasPermissions) && tool.type !== 'road') {
                    <button
                        type="button"
                        class="btn btn-default nlr-icon-btn mgl10"
                        [ngClass]="{'active': isEditorActive()}"
                        [title]="getAttributeEditorTooltip()"
                        [disabled]="editAttributesIsDisabled()"
                        (click)="openAttributeEditor()"
                        cdkOverlayOrigin
                        #showAttributeEditorTrigger="cdkOverlayOrigin"
                        data-cdkOverlayContainerSelector="#attributeViewerOverlayContainer">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </button>
                    <ng-template
                        cdkConnectedOverlay
                        [cdkConnectedOverlayPanelClass]="'widgets'"
                        [cdkConnectedOverlayOrigin]="showAttributeEditorTrigger"
                        [cdkConnectedOverlayOpen]="isEditorActive() && tool.useDefaultEditor && isDesignTabActive">
                        <div
                            id="{{tool.type}}AttributeEditor"
                            class="feature-editor"
                            [ngStyle]="editorConfig.style"
                            cdkDrag
                            [cdkDragConstrainPosition]="computeEditorDragPosition"
                            (click)="onClickAttributeEditor()">
                            <div
                                class="col-xs-12 widget-header"
                                cdkDragHandle>
                                <span>Attribute editor</span>
                                <div class="pull-right btn-group btn-group-xs">
                                    <nlrp-help-link
                                        [url]="getAttributeEditorHelpUrl()"
                                        [pageTitle]="getAttributeEditorHelpPageTitle()"></nlrp-help-link>
                                    <i
                                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                                        title="Close"
                                        (click)="closeEditor()">
                                    </i>
                                </div>
                            </div>
                            <div class="widget-content">
                                <div class="col-xs-12">
                                    <p></p>
                                </div>
                                <form
                                    id="{{tool.type}}EditorForm"
                                    name="editorForm"
                                    novalidate
                                    autocomplete="off"
                                    #editorForm="ngForm">
                                    @for (attribute of getEditorAttributes(); track attribute) {
                                        <div>
                                            @if (
                                                (tool.permissions | hasPermissions) && attribute.attributeType === 'DOMAIN' &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': domainAttributeSelect | formFieldHasError}">
                                                    <label
                                                        for="{{tool.type + attribute.prop}}_select"
                                                        class="control-label"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                        {{attribute.name}}
                                                    </label>
                                                    <div class="input-group">
                                                        <ng-select
                                                            class="nlr-ng-select"
                                                            [searchable]="false"
                                                            [clearable]="false"
                                                            [id]="tool.type + attribute.prop + '_select'"
                                                            [name]="tool.type + attribute.prop + '_select'"
                                                            [attr.name]="tool.type + attribute.prop + '_select'"
                                                            [title]="'Select ' + attribute.name"
                                                            [disabled]="attribute.disabled || disabled ||
                                                            (attribute.prop !== 'type' && !attribute.editable) ||
                                                            (tool.permissions | disabledByPermissions)"
                                                            placeholder="Select"
                                                            [items]="attribute.values"
                                                            bindLabel="description"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="isAttributeRequired(attribute)"
                                                            (change)="attributeSelectorChanged(attribute)"
                                                            #domainAttributeSelect="ngModel">
                                                        </ng-select>
                                                    </div>
                                                </div>
                                            }
                                            @if (
                                                attribute.attributeType === 'BOOLEAN' &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': booleanAttributeInput | formFieldHasError}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}"
                                                        for="{{tool.type + attribute.prop}}_checkbox">
                                                        {{attribute.name}}
                                                    </label>
                                                    <div
                                                        class="checkbox mg0"
                                                        title="{{attribute.name}}">
                                                        <div class="checkbox-inline">
                                                            <i
                                                                class="nlrp-icon"
                                                                [ngClass]="{'active': attribute.value,
                                                        'disabled': attribute.disabled,
                                                        'nlrp-icon-check-box-selected' : attribute.value,
                                                        'nlrp-icon-check-box-unselected': !attribute.value}"
                                                                (click)="!attribute.disabled && (attribute.value = !attribute.value)"></i>
                                                            <input
                                                                type="checkbox"
                                                                [id]="tool.type + attribute.prop + '_checkbox'"
                                                                [attr.name]="tool.type + attribute.prop + '_checkbox'"
                                                                [name]="tool.type + attribute.prop + '_checkbox'"
                                                                [(ngModel)]="attribute.value"
                                                                [required]="isAttributeRequired(attribute)"
                                                                [disabled]="!attribute.editable || (tool.permissions | disabledByPermissions)"
                                                                #booleanAttributeInput="ngModel"
                                                                style="visibility: hidden" />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            @if (
                                                attribute.attributeType === 'RADIO' && (tool.permissions | hasPermissions) &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div class="col-xs-12 p0 mgb10">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}"
                                                        for="{{tool.type + attribute.prop}}_radio">
                                                        {{attribute.name}}
                                                    </label>
                                                    @for (option of attribute.values; track option) {
                                                        <label
                                                            title="Select {{attribute.name}}"
                                                            class="nlr-radio"
                                                            [ngClass]="{
                                                    disabled: attribute.disabled,
                                                    'has-error': radioAttributeInput | formFieldHasError,
                                                    'nlr-radio-required-error': !attribute.value && editorForm.submitted && isAttributeRequired(attribute)
                                                }">
                                                            <input
                                                                type="radio"
                                                                [id]="tool.type + attribute.prop + '_radio'"
                                                                [attr.name]="tool.type + attribute.prop + '_radio'"
                                                                [name]="tool.type + attribute.prop + '_radio'"
                                                                [value]="option.value"
                                                                [(ngModel)]="attribute.value"
                                                                [required]="isAttributeRequired(attribute)"
                                                                [disabled]="!attribute.editable || (tool.permissions | disabledByPermissions)"
                                                                #radioAttributeInput="ngModel" />
                                                            <span>{{option.description}}</span>
                                                        </label>
                                                    }
                                                </div>
                                            }
                                            @if (
                                                (tool.permissions | hasPermissions) && attribute.attributeType?.includes('STRING') &&
                        attribute.attributeTypeLength <= 20 &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': stringAttributeInput | formFieldHasError}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}"
                                                        for="{{tool.type + attribute.prop}}_textinput">
                                                        {{attribute.name}}
                                                    </label>
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            autocomplete="off"
                                                            [placeholder]="'Enter ' + attribute.name"
                                                            [title]="'Enter ' + attribute.name"
                                                            [id]="tool.type + attribute.prop + '_textinput'"
                                                            [name]="tool.type + attribute.prop + '_textinput'"
                                                            [attr.name]="tool.type + attribute.prop + '_textinput'"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="isAttributeRequired(attribute)"
                                                            [maxLengthInputLimit]="attribute.attributeTypeLength"
                                                            [disabled]="!attribute.editable || (tool.permissions | disabledByPermissions)"
                                                            #stringAttributeInput="ngModel" />
                                                    </div>
                                                </div>
                                            }
                                            @if (
                                                (tool.permissions | hasPermissions) &&
                        attribute.attributeType?.includes('STRING') &&
                        attribute.attributeTypeLength > 20 &&
                        (attribute.parentAttribute === null || attribute.showBasedOnParent) &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': stringAttributeTextarea | formFieldHasError}">
                                                    <label
                                                        class="control-label"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}"
                                                        for="{{tool.type + attribute.prop}}_textarea">
                                                        {{attribute.name}}
                                                    </label>
                                                    <div class="input-group">
                                                        <span class="input-group-addon corner"
                                                            ><i class="nlrp-icon nlrp-icon-edit corner-icon"></i
                                                        ></span>
                                                        <textarea
                                                            class="form-control"
                                                            rows="4"
                                                            [id]="tool.type + attribute.prop + '_textarea'"
                                                            [attr.name]="tool.type + attribute.prop + '_textarea'"
                                                            [name]="tool.type + attribute.prop + '_textarea'"
                                                            [placeholder]="'Enter ' + attribute.name"
                                                            [title]="'Enter ' + attribute.name"
                                                            [disabled]="!attribute.editable || (tool.permissions | disabledByPermissions)"
                                                            [required]="isAttributeRequired(attribute)"
                                                            [readonly]="attribute.readyOnlyBasedOnParent"
                                                            [maxLengthInputLimit]="attribute.attributeTypeLength"
                                                            [(ngModel)]="attribute.value"
                                                            #stringAttributeTextarea="ngModel">
                                                        </textarea>
                                                    </div>
                                                </div>
                                            }
                                            @if (
                                                (tool.permissions | hasPermissions) && attribute.attributeType?.includes('INTEGER') &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': integerAttributeInput | formFieldHasError}">
                                                    <label
                                                        class="control-label"
                                                        for="{{tool.type + attribute.prop}}_integer"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                        {{attribute.name}}
                                                    </label>
                                                    <div class="input-group">
                                                        <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                        <input
                                                            type="number"
                                                            class="form-control"
                                                            [id]="tool.type + attribute.prop + '_integer'"
                                                            [attr.name]="tool.type + attribute.prop + '_integer'"
                                                            [name]="tool.type + attribute.prop + '_integer'"
                                                            [placeholder]="'Enter ' + attribute.name"
                                                            [title]="'Enter ' + attribute.name"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="isAttributeRequired(attribute)"
                                                            [nlrPattern]="attribute.pattern"
                                                            [min]="attribute.editable ? attribute.min : 0"
                                                            [max]="attribute.max"
                                                            [disabled]="!attribute.editable || (tool.permissions | disabledByPermissions)"
                                                            [nlrForbiddenValues]="getForbiddenValues(attribute)"
                                                            #integerAttributeInput="ngModel" />
                                                    </div>
                                                    @if (integerAttributeInput | formFieldHasError) {
                                                        <div class="help-block">
                                                            <span>Error!</span>
                                                            @if (!integerAttributeInput.errors?.nlrForbiddenValues) {
                                                                <span> {{attribute.name}} value is invalid. </span>
                                                            }
                                                            @if (integerAttributeInput.errors?.nlrForbiddenValues) {
                                                                <span>Lot number already in use</span>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            @if (
                                                (tool.permissions | hasPermissions) && attribute.attributeType?.includes('DECIMAL') &&
                        (selectedAttrsList.length === 0 || selectedAttrsList.length === 1 || attribute.bulkUpdate)
                                            ) {
                                                <div
                                                    class="col-xs-12 p0 mgb10"
                                                    [ngClass]="{'has-error': decimalAttributeInput | formFieldHasError}">
                                                    <label
                                                        class="control-label"
                                                        for="{{tool.type + attribute.prop}}_decimal"
                                                        [ngClass]="{'required-input': isAttributeRequired(attribute)}">
                                                        {{attribute.name}}:
                                                    </label>
                                                    <div class="input-group">
                                                        <span class="input-group-addon">
                                                            <i class="nlrp-icon nlrp-icon-edit"></i>
                                                        </span>
                                                        <input
                                                            type="number"
                                                            class="form-control"
                                                            step="0.01"
                                                            [id]="tool.type + attribute.prop + '_decimal'"
                                                            [attr.name]="tool.type + attribute.prop + '_decimal'"
                                                            [name]="tool.type + attribute.prop + '_decimal'"
                                                            [placeholder]="'Enter ' + attribute.name"
                                                            [title]="'Enter ' + attribute.name"
                                                            [(ngModel)]="attribute.value"
                                                            [required]="isAttributeRequired(attribute)"
                                                            [nlrPattern]="attribute.pattern"
                                                            [disabled]="!attribute.editable || (tool.permissions | disabledByPermissions)"
                                                            #decimalAttributeInput="ngModel" />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </form>
                            </div>
                            <div class="col-xs-12 widget-footer">
                                @if (tool.permissions | hasPermissions) {
                                    <button
                                        type="button"
                                        id="applyAttributeChangesBtn"
                                        class="btn btn-default nlr-btn-sm"
                                        title="Apply"
                                        (click)="saveEditor()"
                                        [disabled]="isDisabled() || (tool.permissions | disabledByPermissions)">
                                        Apply
                                    </button>
                                }
                                <button
                                    type="button"
                                    class="btn btn-warning nlr-btn-sm"
                                    (click)="closeEditor()"
                                    title="Close">
                                    Close
                                </button>
                            </div>
                        </div>
                    </ng-template>
                }
            </span>
        </div>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayPanelClass]="'widgets'"
        [cdkConnectedOverlayOrigin]="showColumnSettingsTrigger"
        [cdkConnectedOverlayOpen]="showColumnSettings">
        <div
            id="{{tool.type}}ColumnSettingsFeatureWidget"
            class="feature-column-settings"
            cdkDrag
            [cdkDragConstrainPosition]="computeDragPosition"
            (click)="onClickColumnSettingsWidget()">
            <div
                class="col-xs-12 widget-header"
                cdkDragHandle>
                <span>Select columns</span>
                <div class="pull-right btn-group btn-group-xs">
                    <nlrp-help-link
                        [url]="getColumnChooserHelpUrl()"
                        [pageTitle]="getColumnChooserHelpPageTitle()"></nlrp-help-link>

                    <i
                        class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                        title="Close"
                        (click)="showColumnSettings = false">
                    </i>
                </div>
            </div>
            <div class="widget-content">
                <div class="col-xs-12">
                    <h6>Select the columns to be displayed.</h6>
                </div>
                @for (attribute of getAttributesInDisplayOrder(); track attribute) {
                    <div
                        class="col-xs-12 checkbox-inline"
                        [ngClass]="{disabled: !attribute.hideColumn}"
                        (click)="showOrHideColumn(attribute)">
                        <i
                            class="nlrp-icon"
                            [ngClass]="{'active': attribute.display,
                       'nlrp-icon-check-box-selected' : attribute.display,
                       'nlrp-icon-check-box-unselected': !attribute.display}"
                            tabindex="0"
                            title="Show/hide attribute"></i>
                        <span tabindex="0">{{attribute.name}}</span>
                    </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayPanelClass]="'widgets'"
        [cdkConnectedOverlayOrigin]="showFilterTrigger"
        [cdkConnectedOverlayOpen]="showFilter">
        @if (showFilter) {
            <div
                id="{{tool.type}}FilterFeaturesWidget"
                class="feature-filter-settings"
                cdkDrag
                [cdkDragConstrainPosition]="computeDragPosition"
                (click)="onClickFilterFeaturesWidget()">
                <div
                    class="col-xs-12 widget-header"
                    cdkDragHandle>
                    <span>Filter list</span>
                    <div class="pull-right btn-group btn-group-xs">
                        <nlrp-help-link
                            [url]="getFilterHelpUrl()"
                            [pageTitle]="getFilterHelpPageTitle()"></nlrp-help-link>
                        <i
                            class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                            title="Close"
                            (click)="showFilter = false">
                        </i>
                    </div>
                </div>
                <div class="widget-content container-fluid">
                    <div class="row">
                        <div class="col-xs-12">
                            <h6>Enter filter selection criteria.</h6>
                        </div>
                    </div>
                    @for (attribute of options.columns; track attribute) {
                        <div class="row">
                            @if (attribute.name) {
                                <div>
                                    <div class="col-xs-5">
                                        <label
                                            class="control-label"
                                            for="{{attribute.prop}}">
                                            {{attribute.name}}
                                        </label>
                                    </div>
                                    <div class="col-xs-7">
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i class="nlrp-icon nlrp-icon-edit"></i>
                                            </span>
                                            <input
                                                type="text"
                                                [attr.name]="attribute.prop"
                                                [name]="attribute.prop"
                                                class="form-control"
                                                [(ngModel)]="attribute.filterValue"
                                                autocomplete="off"
                                                [nlrTypehead]="filterFeaturesSearch(attribute)"
                                                placeholder="Enter {{attribute.name}}"
                                                title="Select {{attribute.name}}"
                                                [disabled]="disabled" />
                                            <span class="input-group-addon">
                                                <i class="nlrp-icon nlrp-icon-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
                <div class="col-xs-12 widget-footer">
                    <button
                        type="button"
                        class="btn btn-default nlr-btn-sm"
                        title="Apply filter settings"
                        (click)="applyFilter()">
                        Apply
                    </button>
                    <button
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        title="Close filter settings"
                        (click)="showFilter = false">
                        Close
                    </button>
                    <button
                        type="button"
                        class="btn btn-default nlr-btn-sm"
                        title="Clear filter settings"
                        (click)="clearFilter()">
                        Clear
                    </button>
                </div>
            </div>
        }
    </ng-template>

    @if (options.columns.length && attrsList) {
        <div
            class="col-xs-12"
            [ngClass]="{'disabled-cursor': isRemoveAssociationDisabled()}">
            <ngx-datatable
                #dataTable
                class="material"
                [messages]="options.messages"
                [rows]="attrsList"
                [columns]="options.columns"
                [columnMode]="ColumnMode.force"
                [selected]="selectedAttrsList"
                [selectionType]="options.singleSelect ? SelectionType.single : SelectionType.multi"
                [rowHeight]="30"
                [headerHeight]="32"
                [footerHeight]="0"
                [scrollbarH]="true"
                [scrollbarV]="true"
                [displayCheck]="displayCheck"
                [selectCheck]="displayCheck"
                [sortType]="SortType.multi"
                [enableClearingSortState]="true"
                [externalSorting]="true"
                [sorts]="sorts"
                (treeAction)="onTreeAction($event)"
                (select)="onSelect($event)"
                (sort)="onSort($event)">
            </ngx-datatable>
        </div>
    }
</div>
